import React from 'react';
import { translate } from '../../../Services/translation';
import { setActiveTab } from '../../../Actions/QuickSearch.action';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';

const QuickSearchResultTabItem = ({ resultKey, quantity, active }) => {
  const dispatch = useDispatch();
  var translation = translate(`quicksearchheader.${resultKey}`);
  return (
    <li
      className={clsx(
        '[&_span]:h4',
        'relative cursor-pointer whitespace-nowrap border-solid border-gray-900',
        'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-gray-700 after:opacity-0 after:transition after:ease-in-out after:content-[""] group-[.is-light-theme]:after:bg-white',
        'hover:after:opacity-100',
        active && 'after:opacity-100'
      )}
    >
      <button onClick={() => dispatch(setActiveTab(resultKey))}>
        <span>{translation}</span>
        <span> {'(' + quantity + ')'}</span>
      </button>
    </li>
  );
};

export default QuickSearchResultTabItem;
